import { Compass, BookHeart, Landmark, Users, Sparkles, Globe2 } from "lucide-react";

const VALUES = [
  { icon: BookHeart, title: "Preserving Literary Heritage", body: "We are committed to preserving and sharing timeless literary heritage." },
  { icon: Globe2, title: "Global Reach for Indian Literature", body: "We bring India's literary treasures to readers around the world." },
  { icon: Landmark, title: "Past for Future", body: "We preserve the past to inspire future generations." },
  { icon: Sparkles, title: "Joy of Reading", body: "We celebrate knowledge, culture, and the joy of reading." },
  { icon: Compass, title: "Wisdom Connection", body: "We connect readers with India's timeless wisdom." },
  { icon: Users, title: "Rich Traditions", body: "We are dedicated to promoting India's rich literary traditions." },
];

export default function Values() {
  return (
    <div className="bg-[#fafaf9] min-h-screen" data-testid="values-page">
      <section className="bg-[#09090b] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
          style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #ffffff 1px, transparent 0)", backgroundSize: "24px 24px" }} />
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 relative">
          <div className="inline-flex items-center gap-2 border border-[#ea580c]/40 bg-[#ea580c]/10 text-[#fb923c] px-3 py-1.5 text-xs font-bold tracking-[0.2em] uppercase mb-6">
            <Sparkles className="w-3.5 h-3.5" /> Goals &amp; Values
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-[0.95]" data-testid="values-title">
            What guides <span className="text-[#fb923c]">every book</span> we choose.
          </h1>
          <p className="mt-6 text-base md:text-lg text-[#a1a1aa] max-w-2xl">
            Our values are not decorations. They shape every curation decision, every conversation with publishers, and every parcel that reaches your door.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {VALUES.map(({ icon: Icon, title, body }, i) => (
            <div key={title} className="bg-white border border-[#e7e5e4] hover:border-[#09090b] p-6 transition-colors" data-testid={`value-card-${i}`}>
              <div className="inline-flex w-11 h-11 items-center justify-center border border-[#fed7aa] bg-[#fff7ed]">
                <Icon className="w-5 h-5 text-[#ea580c]" strokeWidth={2.2} />
              </div>
              <div className="mt-5 font-display font-black text-lg text-[#09090b] leading-tight">{title}</div>
              <p className="mt-2 text-sm text-[#57534e] leading-relaxed">{body}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
